import { Map } from 'immutable';


const emptyMap = Map();

const defaultTokens = state => {
  const enums = state.enums.get('enums');

  return enums.default_tokens || emptyMap;
};

const enumsSelectors = Object.freeze({
  defaultTokens,
});

export default enumsSelectors;

